<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título -->
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">Lista de recargos</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Visualiza el resumen de recargos generados.
          </div>
        </v-col>
      </v-row>

      <!-- Tabla Desktop -->
      <v-data-table class="d-none d-sm-block" hide-default-header :items="cedentes">
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Id</th>
              <th class="header__title center">Cedente</th>
              <th class="header__title center">Monto total</th>
              <th class="header__title center">Interes</th>
              <th class="header__title center">Capital</th>
              <th class="header__title center">Estatus</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in cedentes" :key="item.id">
              <td class="table__item">{{ item.id }}</td>
              <td class="table__item">{{ item.cedente_name }}</td>
              <td class="table__item center">{{ formatMoney(parseFloat(item.total_principal) + parseFloat(item.total_interest)) + " USD" }}</td>
              <td class="table__item center">{{ formatMoney(item.total_interest) + " USD" }}</td>
              <td class="table__item center">{{ formatMoney(item.total_principal) + " USD" }}</td>
              <td class="table__item center" style="text-transform: capitalize;">{{ item.status }}</td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="verDetalle(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver facturas</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla Mobile -->
      <v-data-table class="d-sm-none d-block" hide-default-header :items="cedentes">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>Cedente</strong><div>{{ item.cedente_name }}</div></td>
              <td class="table__item__mobile"><strong>Total Recargos</strong><div>{{ formatMoney(item.total_recargos) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Pagado</strong><div>{{ formatMoney(item.total_pagado) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Pendiente</strong><div>{{ formatMoney(item.total_pendiente) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Último Recargo</strong><div>{{ formatDate(item.ultimo_recargo) }}</div></td>
              <td class="table__item__mobile d-flex justify-end">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="verDetalle(item)"  v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver facturas</span>
                </v-tooltip>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      cedentes: [],
    }
  },
  methods: {
    async getRecargos() {
      try {
        const response = await DB.get(`${URI}/api/v1/en/chargebacks/resumen-recargos`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        this.cedentes = response.data.cedentes
      } catch (err) {
        console.error(err)
      }
    },
    formatMoney(value) {
      return "$ " + new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0)
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    verDetalle(item) {
      this.$router.push({
        name: 'detalleRecargosCedente',
        params: { cedenteId: item.cedente_enterprise_id }
      })
    }
  },
  mounted() {
    this.getRecargos()
  }
}
</script>
